module.exports = __webpack_public_path__ + "static/media/medical-bldgs-landscape.389b7f8a.png";